import {BASE_PATH, BASE_PATH_EXTENSION, BASE_PATH_EXTENSION_ADMIN} from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/service`;

export async function listServiceApi() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/`, config)
}

export async function listServiceOrganizationApi(organizationId) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/get-service-list-org/${organizationId}`, config)
}

export async function getServiceApi(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/get-service`, props, config)
}

export async function showServicesApi() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/listall`, null, config)
}

export async function createApi(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/create`, props, config)
}

export async function updateServiceApi(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/update`, props, config)
}
